import { css } from '@emotion/core';
import { media, tokens } from '@domain-group/fe-brary';
import { designTokenFonts, truncateLines } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var features = /*#__PURE__*/css("display:flex;margin:0 0 0 16px;color:", colors.neutral.heavy.default, ";margin-top:12px;");
export var feature = {
  name: "tm4b37",
  styles: "&:not(:last-child){margin-right:8px;}"
};
export var featureIcon = /*#__PURE__*/css("width:18px;height:18px;margin-right:4px;", media('>=desktop'), "{width:24px;height:24px;}");
export var featureValue = /*#__PURE__*/css(designTokenFonts.bodyBold, " display:inline-block;vertical-align:baseline;");
export var featuresIcons = {
  name: "1xm3w9l",
  styles: "display:inline-block;white-space:nowrap;"
};
var valueCommon = /*#__PURE__*/css(designTokenFonts.bodyBold, " margin-left:4px;");
var additionalFeature = {
  name: "1baulvz",
  styles: "display:inline-block;"
};
export var size = /*#__PURE__*/css(additionalFeature, ";margin-right:8px;");
export var sizeValue = /*#__PURE__*/css(valueCommon, ";");
export var sizeSuperscript = {
  name: "9z1ck9",
  styles: "vertical-align:super;"
};
export var type = /*#__PURE__*/css("display:inline-block;", truncateLines(1));
export var typeIcon = {
  name: "1v994a0",
  styles: "margin-right:6px;"
};
export var typeValue = /*#__PURE__*/css(valueCommon, ";margin:auto 4px 0 0;");
export var separator = {
  name: "1w3zzgl",
  styles: "&::before{content:'\u2022';margin:auto 7px;}"
};